import { render, staticRenderFns } from "./account.vue?vue&type=template&id=8776457a&scoped=true"
import script from "./account.vue?vue&type=script&lang=ts"
export * from "./account.vue?vue&type=script&lang=ts"
import style0 from "./account.vue?vue&type=style&index=0&id=8776457a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8776457a",
  null
  
)

export default component.exports